import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ClubTileComponent} from './club-tile.component';
import {ImageVariantModule} from '@tisa-group/core';
import {TuiSvgModule} from '@taiga-ui/core';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
  declarations: [ClubTileComponent],
  imports: [CommonModule, ImageVariantModule, TuiSvgModule, TranslateModule],
  exports: [ClubTileComponent],
})
export class ClubTileModule {}
